import { useEffect } from 'react'

import { styled } from 'styled-components'

import {
  Banner,
  FormattedMessage,
  ddLogger,
} from '@b-stock/fe-core/bstock-react'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

type LogInfo = {
  level: 'warn' | 'error'
  message: string
  metadata: Record<string, unknown>
}

type Props = {
  titleId: string
  messageId: string
  log: LogInfo
}

export const MissingDataBanner = ({ titleId, messageId, log }: Props) => {
  // Log once per mount: missing-data state is fixed for the life of this
  // component, so we don't need to react to changes in `log` after the first
  // fire. Empty deps avoids re-running on every parent re-render (call sites
  // pass a fresh object literal).
  useEffect(() => {
    ddLogger[log.level](log.message, log.metadata)
  }, []) // oxlint-disable-line react/exhaustive-deps

  return (
    <Wrapper role="alert" data-testid="missing-data-banner">
      <Banner type="warning" title={<FormattedMessage id={titleId} />}>
        <FormattedMessage id={messageId} />
      </Banner>
    </Wrapper>
  )
}
